import { registerModuleDataProvider } from '../../../providers/CustomDataProvider';
import { activityTaskCompletionStats } from './dataProvider';

// 注册 activity/tasks 模块的数据提供者
export function initActivityTasksDataProvider() {
  registerModuleDataProvider('activityTaskCompletionStats', activityTaskCompletionStats);
}

// 自动初始化
initActivityTasksDataProvider();
